import React from "react";
import { createRoot } from "react-dom/client";
import SeoTitleGenerator from "../components/free-tools/SeoTitleGenerator";
import ToastProvider from "../components/shared/ToastProvider";

document.addEventListener("DOMContentLoaded", () => {
  const rootElement = document.getElementById("seo-title-generator-main");
  if (rootElement) {
    const root = createRoot(rootElement);
    root.render(
      <>
        <ToastProvider />
        <SeoTitleGenerator />
      </>
    );
  }
});
